<template lang='pug'>
  .rewards-boutique
    Header(:current-user='currentUser')
    RewardsSection(
      v-if='lowRewards().length'
      :is-guest-user='isGuestUser'
      :cart-samples='cartSampleIds'
      :title='$t("account.rewardsBoutique.rewardsSection.lowRewardsTitle")'
      :rewards='lowRewards()')
    RewardsSection(
      v-if='highRewards().length'
      :is-guest-user='isGuestUser'
      :cart-samples='cartSampleIds'
      :title='$t("account.rewardsBoutique.rewardsSection.highRewardsTitle")'
      :rewards='highRewards()')
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AccountNav from '../account/nav.vue'
import Header from './header.vue'
import RewardsSection from './rewards-section.vue'
import { notificationMixin } from '@/mixins/notificationMixin'

export default {
  name: 'RewardsBoutique',

  components: {
    AccountNav,
    Header,
    RewardsSection
  },

  mixins: [notificationMixin],

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      rewards: state => state.reward.rewards,
      cartSamples: state => state.cart.cartSamples
    }),

    cartSampleIds () {
      return this.cartSamples.map((sample) => sample.id)
    },

    isGuestUser () {
      return !this.currentUser
    }
  },

  async created () {
    this.$store.commit('setSeoMetaTitle', window.vue.$t('account.rewardsBoutique.title'))
    this.$store.commit('setSeoUpdate', true)
    this.displayKRShutdownMessage()
    await this.fetchRewards()
  },

  methods: {
    ...mapActions(['fetchRewards']),
    ...mapGetters([
      'lowRewards',
      'highRewards'
    ])
  }
}
</script>
